export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Reach Out to Us',
      description: 'Call us or fill out our quick quote form. Tell us about your move—where you\'re going, what you\'re moving, and when you need to be there.',
      icon: 'ri-phone-line',
      color: 'amber',
    },
    {
      number: '02',
      title: 'Get Your Custom Estimate',
      description: 'We\'ll provide a transparent, no-obligation quote based on your specific needs. No hidden fees, no surprises—just honest pricing.',
      icon: 'ri-file-list-3-line',
      color: 'sky',
    },
    {
      number: '03',
      title: 'We Pack & Prepare',
      description: 'Our professional team arrives on schedule with all the equipment and materials needed. We handle packing, wrapping, and protecting your belongings.',
      icon: 'ri-box-3-line',
      color: 'emerald',
    },
    {
      number: '04',
      title: 'Safe Transport',
      description: 'Your items are carefully loaded and transported to your new location. We treat everything like it\'s our own, ensuring safe delivery.',
      icon: 'ri-truck-line',
      color: 'violet',
    },
    {
      number: '05',
      title: 'Unpack & Settle In',
      description: 'We unload, place furniture where you want it, and can even help with assembly and picture hanging. You\'re home.',
      icon: 'ri-home-smile-line',
      color: 'rose',
    },
  ];

  return (
    <section id="process" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-sky-100 text-sky-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            How It Works
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Your Move, Simplified in 5 Easy Steps
          </h2>
          <p className="text-xl text-slate-600">
            From first contact to settling into your new home, we make every step stress-free.
          </p>
        </div>

        {/* Vertical Timeline */}
        <div className="max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="absolute left-6 top-24 w-0.5 h-full bg-gradient-to-b from-slate-300 to-transparent hidden sm:block"></div>
              )}

              {/* Step Card */}
              <div className="relative flex flex-col sm:flex-row gap-6 mb-8 group">
                {/* Number Circle */}
                <div className="flex-shrink-0">
                  <div className={`w-12 h-12 rounded-full bg-${step.color}-500 text-white font-bold text-lg flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform`}>
                    {index + 1}
                  </div>
                </div>

                {/* Content Card */}
                <div className="flex-1 bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-slate-200 group-hover:border-slate-300">
                  <div className="flex items-start gap-6">
                    {/* Icon */}
                    <div className={`w-14 h-14 rounded-xl bg-${step.color}-100 flex items-center justify-center flex-shrink-0`}>
                      <i className={`${step.icon} text-2xl text-${step.color}-600`}></i>
                    </div>

                    {/* Text Content */}
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-3">
                        <h3 className="text-2xl font-bold text-slate-900">
                          {step.title}
                        </h3>
                        <span className="text-sm font-mono text-slate-400">{step.number}</span>
                      </div>
                      <p className="text-lg text-slate-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-lg text-slate-600 mb-6">
            Ready to get started? Let's make your move happen.
          </p>
          <a 
            href="#quote-form" 
            className="inline-flex items-center justify-center bg-slate-900 text-white px-8 py-4 rounded-lg font-bold hover:bg-slate-800 transition-colors whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            Start Your Move Today
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}